// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"3395f74a","600":"c0514dde","761":"cda94a2a","923":"aa200c4b","999":"dd20944c"}[chunkId] + ".chunk.js";
};